<nz-spin [nzSpinning]="loading">
  <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
    <nz-row>
      <nz-col [nzFlex]="8">
        @if (bulkContainerObj) {
          <nz-form-item class="slim">
            <nz-form-label [nzSm]="10" [nzXs]="24">Artikel</nz-form-label>
            <nz-form-control [nzSm]="13" [nzXs]="24">
              {{bulkContainerObj.article.name}}
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="slim">
            <nz-form-label [nzSm]="10" [nzXs]="24">Lieferant</nz-form-label>
            <nz-form-control [nzSm]="13" [nzXs]="24">
              {{bulkContainerObj.supplier.name}}
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="slim">
            <nz-form-label [nzSm]="10" [nzXs]="24">Charge</nz-form-label>
            <nz-form-control [nzSm]="13" [nzXs]="24">
              {{bulkContainerObj.charge}}
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="slim">
            <nz-form-label [nzSm]="10" [nzXs]="24">MHD</nz-form-label>
            <nz-form-control [nzSm]="13" [nzXs]="24">
              {{bulkContainerObj.mhd | dateFormat}}
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="slim">
            <nz-form-label [nzSm]="10" [nzXs]="24">Aktueller Lieferzustand</nz-form-label>
            <nz-form-control [nzSm]="13" [nzXs]="24">
              {{bulkContainerObj.state.value | productionUnit:true}}
            </nz-form-control>
          </nz-form-item>
        }
        <nz-divider></nz-divider>
        <nz-form-item>
          <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="isPriority">
            <span>Priorität</span>
          </nz-form-label>
          <nz-form-control [nzSm]="13" [nzXs]="24" >
            <nz-radio-group formControlName="isPriority">
              <label nz-radio [nzValue]=true>Ja</label>
              <label nz-radio [nzValue]=false>Nein</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="processingDate" nzRequired>
            <span>Bearbeitungsdatum</span>
          </nz-form-label>
          <nz-form-control [nzSm]="13" [nzXs]="24" nzErrorTip="Geben Sie die Bearbeitungsdatum!">
            <nz-date-picker
              [nzFormat]="dateFormat"
              formControlName="processingDate"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="worker" nzRequired>
            <span>Bearbeiter</span>
          </nz-form-label>
          <nz-form-control [nzSm]="13" [nzXs]="24" nzErrorTip="Geben Sie die Bearbeiter!">
            <nz-select
              style="max-width: 250px;"
              nzPlaceHolder="Wählen Sie Bearbeiter"
              nzShowSearch
              nzServerSearch
              formControlName="workers"
              (nzOnSearch)="onSearchUsers($event)"
              [compareWith]="compareSimpleList"
              nzMode="multiple"
              >
              @for (o of usersList; track o) {
                @if (!isUsersLoading) {
                  <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
                }
              }
              @if (isUsersLoading) {
                <nz-option nzDisabled nzCustomContent>
                  <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                </nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>

      </nz-col>
      <nz-col [nzFlex]="16">

        @if (bulkContainerObj) {
          @if (stores$ | async; as stores) {
            @for (val of (isEdit ? editObject.productionOrderVariants : bulkContainerObj.article.articleVariants); track val; let i = $index) {
              <nz-form-item
                formArrayName="productionOrderVariants"
                >
                <ng-container [formGroupName]="i">
                  <nz-form-label [nzSm]="14" [nzXs]="24" nzFor="price">
                    @if (!isEdit) {
                      <span>
                        {{val.name}} ({{ ((val.stocks | mainStoreNameByStocks)?.inStock) ?? 0 }})
                      </span>
                    }
                    @if (isEdit) {
                      <span>
                        {{val.articleVariant.name}} ({{ ((val.articleVariant.stocks | mainStoreNameByStocks)?.inStock) ?? 0 }})
                      </span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="10" [nzXs]="24" nzErrorTip="Feld ist erforderlich!">
                    <div>
                      <input type="hidden" formControlName="articleVariantId">
                      <input type="hidden" formControlName="weight" >
                      <input type="hidden" formControlName="customWeight" >
                      <nz-input-number
                        id="quantity"
                        formControlName="quantity"
                        nzMin="0"
                        [class.disabled]="!isEdit ? (!val.customWeight ? (val.purchaseUnit * 1000) : val.customWeight) === 0 : (!val.articleVariant.customWeight ? (val.articleVariant.purchaseUnit * 1000) : val.articleVariant.customWeight) === 0"
                      ></nz-input-number>
                      @if (!isEdit) {
                        <span>
                          ({{ !val.customWeight ? (val.purchaseUnit * 1000) : val.customWeight }} g)
                        </span>
                      }
                      @if (isEdit) {
                        <span>
                          ({{ !val.articleVariant.customWeight ? (val.articleVariant.purchaseUnit * 1000) : val.articleVariant.customWeight }} g)
                        </span>
                        @if (editObject && productionOrderStatuses[editObject.status] === productionOrderStatuses.Posted) {
                          {{ val.targetStoreId | storeNameById:stores }}
                        }
                      }
                      @if (!isEdit ? (!val.customWeight ? (val.purchaseUnit * 1000) : val.customWeight) === 0 : (!val.articleVariant.customWeight ? (val.articleVariant.purchaseUnit * 1000) : val.articleVariant.customWeight) === 0) {
                        <span
                          nz-tooltip
                          nzTooltipTitle="Variante hat kein Gewicht!"
                          nz-icon nzType="question-circle"
                          nzTheme="twotone"
                          style="margin-left: 8px;"
                        ></span>
                      }
                    </div>
                    @if (((!isEdit ? val.name : val.articleVariant.name) | lowercase | stringIncludes:'mit rezeptkarte') || ((!isEdit ? val.name : val.articleVariant.name) | lowercase | stringIncludes:'goodie')) {
                      <div
                        style="margin-top: 10px; max-width: 256px;"
                        >
                        <nz-select
                          nzPlaceHolder="Wählen Sie Rezeptkarte"
                          nzShowSearch
                          nzServerSearch
                          formControlName="recipeCardVariantId"
                          nzAllowClear
                          (nzOnSearch)="onRecipeCardsSearch($event)"
                          >
                          @for (o of recipeCardsList; track o) {
                            @if (!isRecipeCardsLoading) {
                              <nz-option [nzValue]="o.id" [nzLabel]="o.value"></nz-option>
                            }
                          }
                          @if (isRecipeCardsLoading) {
                            <nz-option nzDisabled nzCustomContent>
                              <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                            </nz-option>
                          }
                        </nz-select>
                      </div>
                    }
                  </nz-form-control>
                </ng-container>
              </nz-form-item>
            }
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24" >
                <span>Restmenge</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24" >
                {{ (this.restValue$|async|productionUnit:true) }}
              </nz-form-control>
            </nz-form-item>
          }
        }
        <nz-form-item>
          <nz-form-label [nzSm]="10" [nzXs]="24">Bemerkung</nz-form-label>
          <nz-form-control [nzSm]="13" [nzXs]="24">
            <textarea rows="4" formControlName="comment" nz-input></textarea>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
    </nz-row>

  </form>
</nz-spin>
